import { render, staticRenderFns } from "./input-price.vue?vue&type=template&id=137c105d"
import script from "./input-price.vue?vue&type=script&lang=js"
export * from "./input-price.vue?vue&type=script&lang=js"
import style0 from "./input-price.vue?vue&type=style&index=0&id=137c105d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports